import { PaperProps } from '@mui/material';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { Spinner } from '../Spinner/Spinner';

interface ListLayoutProps extends PaperProps {
  isFirstLoading?: boolean;
  isLoading?: boolean;
  skeletonHeight?: string;
}

export const ListLayout = ({
  children,
  isFirstLoading,
  isLoading,
  skeletonHeight,
  ...props
}: ListLayoutProps) => {
  return (
    <Paper
      {...props}
      sx={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        position: 'relative',
      }}
    >
      <Stack sx={{ height: '100%', width: '100%' }}>
        {isLoading && <Spinner />}
        <Stack
          gap={0}
          sx={{
            height: '100%',
            width: '100%',
          }}
        >
          {isFirstLoading ? (
            <Stack gap={'2px'}>
              {Array.from({ length: 16 }, (_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  width={'100%'}
                  height={skeletonHeight ?? '57px'}
                />
              ))}
            </Stack>
          ) : (
            children
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};
